import { Injectable } from '@angular/core';
import { PackagingActionTypes } from '@app/modules/core/actions';
import * as ColorActionTypes from '@app/modules/core/actions/color.actions';
import * as CoverActions from '@app/modules/core/actions/cover.actions';
import * as discrepancyActions from '@app/modules/core/actions/discrepancy.actions';
import * as FileActions from '@app/modules/core/actions/file.actions';
import * as followActions from '@app/modules/core/actions/follow.actions';
import * as NotificationActions from '@app/modules/core/actions/notification.actions';
import * as PortActions from '@app/modules/core/actions/port.actions';
import * as ProductActionTypes from '@app/modules/core/actions/product.actions';
import * as ProformaActions from '@app/modules/core/actions/proforma.actions';
import * as ProvidersActions from '@app/modules/core/actions/provider.actions';
import * as ReportActions from '@app/modules/core/actions/reports.actions';
import * as Sustainability from '@app/modules/core/actions/sustainability.action';
import * as NewProductFileActions from '@app/modules/file-upload/actions/new-product-file.actions';
import * as packagingActions from '@core/actions/packaging.actions';
import * as RetroplanningActions from '@core/actions/retroplanning.actions';
import * as ShippingTimesActions from '@core/actions/shipping-time.actions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';

declare var io;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  socket;
  files = [];
  bookUniqId;
  templateUniqId;
  ocmUniqId;
  exportGroupId;
  exportShippingMarksId;
  exportDiscrepanciesId;
  constructor(private store: Store<any>, private modal: NgbModal) {}

  connect(token) {
    console.log(
      `connecting ws to ${environment.SOCKET_URL}?accessToken=${token}`
    );

    //this.socket = io(`${environment.SOCKET_URL}?accessToken=${token}`, {
    this.socket = io(environment.SOCKET_URL, {
      transports: [environment.WS_TRANSPORT],
      // transports: ['polling'],
      path: environment.SOCKET_PATH ? environment.SOCKET_PATH : undefined
    });

    this.socket.on('connect', () => {
      console.log('Connected to WS: ', this.socket.id);
      this.socket.emit('auth', { token });
    });

    this.socket.on('authenticated', data => {
      console.log('Auth OK');
    });

    this.socket.on('LoadFileJob', data => {
      if (data.status === 'pending') {
        this.store.dispatch(new NewProductFileActions.ProcessFileUpdate(data));
      } else if (data.status === 'processed') {
        this.store.dispatch(
          new NewProductFileActions.ProcessFileSuccess(data, 'follow')
        );
        // this.files = this.files.filter(f => f !== data.FileId);
      } else if (data.status === 'failed') {
        this.store.dispatch(new NewProductFileActions.ProcessFileFail(data));
      } else if (data.status === 'cancelled') {
        this.store.dispatch(
          new NewProductFileActions.CancelImportProducts(
            data.FileId,
            data.status
          )
        );
      }
    });

    this.socket.on('GenerateOrderSummary', data => {
      if (data.status === 'pending') {
        this.store.dispatch(new FileActions.ExportOrderSummaryPending(data));
      } else if (data.status === "success") {
        this.store.dispatch(new FileActions.ExportOrderSummarySuccess(data));
      }
    });
    
    this.socket.on("UpdatePortsFile", data => {
      if(data.status === "success"){
        this.store.dispatch(new PortActions.Load());
      }
      if(data.status === "pending"){
        this.store.dispatch(new PortActions.UploadProcessPending());
      }
    })

    this.socket.on("ExportAllPosters", data => {
      if(data.status === "success"){
        this.store.dispatch(new FileActions.DownloadPostersFinal(data.downloadUrl, data.FollowId));
      }
      if(data.status === "pending"){
        this.store.dispatch(new FileActions.ExportFollowPending(data));
      }
    })

    this.socket.on('ExportPackagingMassive', data => {
      if (data.status === 'success') {
        this.store.dispatch(
          new packagingActions.PackagingExportMassiveSuccess(data.message, data.zip, data.FollowId)
        );
        // this.store.dispatch(new FileActions.ExportOrderSummaryPending(data));
      }
      if (data.status === "pending") {
        this.store.dispatch(
          new packagingActions.PackagingExportMassivePending(data.message)
        );
      }
    });

    this.socket.on('ExportPackagingWS', data => {
      if (data.status === 'success') {
        this.store.dispatch(new packagingActions.ExportPackagingJobSuccess(data.data, data.name));

        // this.store.dispatch(
        //   new packagingActions.PackagingExportMassiveSuccess(data.message, data.zip)
        // );
        // this.store.dispatch(new FileActions.ExportOrderSummaryPending(data));
      }
      if (data.status === "pending") {
        this.store.dispatch(new packagingActions.ExportPackagingPending(data.message));

        // this.store.dispatch(
        //   new packagingActions.PackagingExportMassivePending(data.message)
        // );
      }
    });

    this.socket.on('PackagingFieldsUpdate', data => {
      if (data.status === 'fail') {
        this.store.dispatch(new packagingActions.PackagingFieldsUpdateFail(data.data));

        // this.store.dispatch(
        //   new packagingActions.PackagingExportMassiveSuccess(data.message, data.zip)
        // );
        // this.store.dispatch(new FileActions.ExportOrderSummaryPending(data));
      }
      if (data.status === "success") {
        this.store.dispatch(new packagingActions.ExportPackagingPending(data.message));

        // this.store.dispatch(
        //   new packagingActions.PackagingExportMassivePending(data.message)
        // );
      }
      if (data.status === "pending") {
        this.store.dispatch(new packagingActions.ExportPackagingPending(data.message));

        // this.store.dispatch(
        //   new packagingActions.PackagingExportMassivePending(data.message)
        // );
      }
    });

    this.socket.on('BatchImageUploadJobUpdate', data => {
      if (data.status === 'success' && data.uploadType === 'image') {
        this.store.dispatch(
          new NewProductFileActions.ClearStateProductFilePage(data)
        );
      } else if (data.status === 'fail' && data.uploadType === 'image') {
        this.store.dispatch(new NewProductFileActions.NotifyApi());
      } else {
        if (this.files.includes(data.FileId)) {
          if (data.status === 'success') {
            this.store.dispatch(
              new NewProductFileActions.ClearStateProductFilePage(data)
            );
          } else {
            if (data.status === 'pending') {
              console.log();
              this.store.dispatch(
                new NewProductFileActions.ProcessFileUpdate(data)
              );
            } else if (data.status === 'processed') {
              this.store.dispatch(
                new NewProductFileActions.ProcessFileSuccess(data, 'image')
              );
              // this.files = this.files.filter(f => f !== data.FileId);
            } else if (data.status === 'fail') {
              this.store.dispatch(new NewProductFileActions.NotifyApi());
            }
          }
        }
      }
    });

    this.socket.on('NotificationUpdate', data => {
      this.store.dispatch(
        new NotificationActions.UpdateCounter(data.count || 0)
      );
    });

    this.socket.on('BatchSingleImageUploadJob', data => {
      this.store.dispatch(
        new ProductActionTypes.UpdateOne(data.product)
      )
      this.store.dispatch(
        new FileActions.UploadSingleImageSecondSuccess()
      )
    })

    this.socket.on('CreateProductsJob', data => {
      if (this.files.includes(data.FileId)) {
        if (data.status === 'pending') {
          this.store.dispatch(
            new NewProductFileActions.ConfirmFileUpdate(data)
          );
        } else if (data.status === 'complete') {
          this.store.dispatch(
            new NewProductFileActions.ConfirmFileSuccess(data)
          );
          this.files = this.files.filter(f => f !== data.FileId);
        }
      }
    });

    this.socket.on('ProcessingPackagingLoad', data => {
      // if (this.files.includes(data.FileId)) {
        // console.log("DATA ->", data)
        if (data.status === 'pending') {
          this.store.dispatch(
            new packagingActions.PackagingPendingMessage(data.message)
          );
        } else {
          this.store.dispatch(
            new packagingActions.PackagingPendingMessage("")
          );
        }
        //  else if (data.status === 'complete') {
        //   this.store.dispatch(
        //     new NewProductFileActions.ConfirmFileSuccess(data)
        //   );
        //   this.files = this.files.filter(f => f !== data.FileId);
        // }
      // }
    });

    this.socket.on('ProcessingPackagingLoadOrder', data => {
      this.store.dispatch(
        new packagingActions.ExportPackOrderLoadSuccess(data.packId)
      );
    });

    this.socket.on('uploadSpecialOcm', data => {
        switch (data.status) {
          case 'success':
            this.store.dispatch(
              new NewProductFileActions.UploadFileSuccess(data)
            );
            break;

          case 'failed':
            this.store.dispatch(new NewProductFileActions.UploadFileFail(data));
            break;
        }
    });

    this.socket.on('GenerateBookUpdate', data => {
      if (this.bookUniqId === data.uniqId) {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(
              new NewProductFileActions.GenerateBookUpdate(data)
            );
            break;

          case 'success':
            this.store.dispatch(
              new NewProductFileActions.GenerateBookSuccess(data)
            );
            break;

          case 'failed':
            this.store.dispatch(new NewProductFileActions.GenerateBookFail());
            break;
        }
      }
    });

    this.socket.on("ExportMP", data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new FileActions.ExportMPPending(data));
          break;

        case 'success':
          this.store.dispatch(new FileActions.ExportMPSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new FileActions.ExportMPFail());
          break;
      }
    })

    this.socket.on('GenerateTemplateUpdate', data => {
      //todo bookdownloadId
      console.log(this.templateUniqId, ' - ', data.templateUniqId);
      
      if (
        data.type !== 'templateFollow' &&
        this.templateUniqId &&
        this.templateUniqId !== undefined &&
        this.templateUniqId === data.templateUniqId
      ) {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new FileActions.GenerateTemplate(data));
            break;

          case 'success':
            this.store.dispatch(new FileActions.GenerateTemplateSuccess(data));
            break;

          case 'failed':
            this.store.dispatch(new FileActions.GenerateTemplateFail());
            break;
        }
      } else {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new FileActions.GenerateTemplate(data));
            break;

          case 'success':
            this.store.dispatch(new FileActions.GenerateTemplateSuccess(data));
            break;

          case 'failed':
            this.store.dispatch(new FileActions.GenerateTemplateFail());
            break;
        }
      }
    });

    this.socket.on('ExportMasterKeyUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new FileActions.GenerateTemplate(data));
          break;

        case 'success':
          this.store.dispatch(new FileActions.GenerateTemplateSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new FileActions.GenerateTemplateFail());
          break;
      }
    });

    this.socket.on('GenerateGlobalOCM', data => {
      if(`${this.ocmUniqId}` === data.uniqTemplateId){
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new FileActions.ExportGlobalOcmPending(data));
            break;
  
          case 'success':
            this.store.dispatch(new FileActions.ExportGlobalOcmComplete(data));
            break;
  
          case 'failed':
            this.store.dispatch(new FileActions.ExportGlobalOcmFail());
            break;
        }
      }
    });

    this.socket.on('GenerateProviders', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new FileActions.ExportProformaPending(data));
          break;

        case 'success':
          this.store.dispatch(new FileActions.ExportProvidersSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new FileActions.ExportProformaFail());
          break;
      }
    });

    this.socket.on("LoadDiscrepanicesWebJob", data => {
      console.log("DATA STATUS ->", data)
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ProformaActions.DiscrepanciesWebLoad(data.message));
          break;

        case 'success':
          this.store.dispatch(new ProformaActions.DiscrepanciesWebLoadSuccess(data.records));
          break;

        case 'failed':
          this.store.dispatch(new ProformaActions.DiscrepanciesWebLoadFail());
          break;
      }
    })

    this.socket.on('ExportGroupUpdate', data => {
      if (this.exportGroupId === data.exportGroupId) {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new ProformaActions.ExportGroupUpdate(data));
            break;

          case 'success':
            this.store.dispatch(new ProformaActions.ExportGroupSuccess(data));
            break;

          case 'failed':
            this.store.dispatch(new ProformaActions.ExportGroupFail(data));
            break;
        }
      }
    });

    // this.socket.on('ExportShippingMarksUpdate', data => {
    //   if (this.exportShippingMarksId === data.exportShippingMarksId) {
    //     switch (data.status) {
    //       case 'pending':
    //         this.store.dispatch(new ProformaActions.ExportGroupUpdate(data));
    //         break;

    //       case 'success':
    //         this.store.dispatch(new ProformaActions.ExportGroupSuccess(data));
    //         break;

    //       case 'failed':
    //         this.store.dispatch(new ProformaActions.ExportGroupFail(data));
    //         break;
    //     }
    //   }
    // });

    this.socket.on('ImplantationProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new NewProductFileActions.ImplantationProcessUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new NewProductFileActions.ImplantationProcessSuccess()
          );
          break;

        case 'failed':
          this.store.dispatch(
            new NewProductFileActions.ImplantationProcessFail(data)
          );
          break;
      }
    });

    this.socket.on('ProvidersFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ProvidersActions.UploadProcessUpdate(data));
          break;

        case 'success':
          this.store.dispatch(new ProvidersActions.UploadProcessSuccess());
          break;

        case 'failed':
          this.store.dispatch(new ProvidersActions.UploadProcessFail(data));
          break;
      }
    });

    this.socket.on('PackagingFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new PackagingActionTypes.UploadProcessUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new PackagingActionTypes.UploadProcessSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(new PackagingActionTypes.UploadProcessFail(data));
          break;
      }
    });
    this.socket.on('SustainabilityMasiveUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new Sustainability.UploadingGroupPending(data));
          break;

        case 'success':
          this.store.dispatch(new Sustainability.UploadingGroupSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(
            new Sustainability.UploadingGroupFail(data.message)
          );
          break;
      }
    });

    this.socket.on('ExportGroupSustainability', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new Sustainability.ExportGroupPending(data));
          break;

        case 'success':
          this.store.dispatch(new Sustainability.ExportGroupSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new Sustainability.ExportGroupFail(data.message));
          break;
      }
    });

    this.socket.on('SustainabilityFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new Sustainability.UploadProcessFile(data));
          break;

        case 'success':
          this.store.dispatch(
            new Sustainability.UploadProcessFileSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(
            new Sustainability.UploadProcessFileFail(data.message)
          );
          break;
      }
    });

    this.socket.on('ProformasFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ReportActions.UploadProcessUpdate(data));
          break;

        case 'success':
          this.store.dispatch(new ReportActions.UploadProcessNewSuccess());
          break;

        case 'failed':
          this.store.dispatch(new ReportActions.UploadProcessFail());
          break;
      }
    });

    this.socket.on('ProformasFileWithoutSku', data => {
      this.store.dispatch(new ProformaActions.ProcessFileSuccess(data))
    })

    this.socket.on('ProformasFileWithSku', data => {
      this.store.dispatch(new ProformaActions.ProcessFileWithSkusSuccess())
    })

    this.socket.on('FollowUpdate', data => {
      this.store.dispatch(new followActions.UpdateOne(data.data));
    });

    this.socket.on('ProcessDiscrepancyFileUpdate', (data) => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new discrepancyActions.ProcessDiscrepancyFileUpdate(data)
          );
          break;

        case 'success':
          if(data.changes && (data.changes.shipmentFob && data.changes.shipmentFob.length && data.changes.products && data.changes.products.length)){
            const productsWithShipment = data.changes.products.map((product) => {
              const aux = data.changes.shipmentFob.filter(
                (shipment) => shipment && shipment.productId === product.productId
              )
            return {
              ...product,
              shipmentFob: aux.length ? aux[0] : aux
            }
            });
            data.changes.products = productsWithShipment
          }
          this.store.dispatch(
            new discrepancyActions.ProcessDiscrepancyFileSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(new discrepancyActions.UploadFileFail(data));
          break;
      }
    });

    this.socket.on('AcceptChangesUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new discrepancyActions.AcceptChangesUpdate(data));
          break;

        case 'success':
          this.store.dispatch(
            new discrepancyActions.AcceptChangesSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(new discrepancyActions.AcceptChangesFail(data));
          break;
      }
    });

    this.socket.on('AcceptGlobalChangesUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new discrepancyActions.AcceptGlobalChangesUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new discrepancyActions.AcceptGlobalChangesSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(
            new discrepancyActions.AcceptGlobalChangesFail(data)
          );
          break;
      }
    });

    this.socket.on('HierarchyCountryFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new FileActions.UploadHierarchyCountryUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new FileActions.UploadHierarchyCountryUpdateSuccess()
          );
          break;

        case 'failed':
          this.store.dispatch(
            new FileActions.UploadHierarchyCountryUpdateFail()
          );
          break;
      }
    });

    this.socket.on('HierarchyPlannerFoodFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new FileActions.UploadHierarchyPlannerFoodUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new FileActions.UploadHierarchyPlannerFoodUpdateSuccess()
          );
          break;

        case 'failed':
          this.store.dispatch(
            new FileActions.UploadHierarchyPlannerFoodUpdateFail()
          );
          break;
      }
    });

    this.socket.on('ColorProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ColorActionTypes.ColorProcessUpdate(data));
          break;

        case 'success':
          this.store.dispatch(new ColorActionTypes.UploadProcessSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new ColorActionTypes.UploadProcessFail(data));
          break;
      }
    });

    this.socket.on("ShippingTimesUpdate", data => {
      switch (data.status) {
        case "success":
          this.store.dispatch(new ShippingTimesActions.UploadSuccess(data.data))
      }
    })


    this.socket.on('DetailProformasUpdate', data => {
      switch (data.status) {
        case 'success':
          this.store.dispatch(new ReportActions.UploadProcessSuccess());
          break;
      }
    });

    this.socket.on('ShippingMarksColorsUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ReportActions.UploadFileShippingMarksXlsxProcess(data));
          break;

        case 'success':
          this.store.dispatch(new ReportActions.UploadFileShippingMarksXlsxProcessSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new ReportActions.UploadFileShippingMarksXlsxProcessFail(data));
          break;
      }
    });

    this.socket.on('BulkColorUploadUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(new ColorActionTypes.ColorProcessUpdate(data));
          break;

        case 'processed':
          this.store.dispatch(new ColorActionTypes.UploadProcessSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new ColorActionTypes.UploadProcessFail(data));
          break;
      }
    });

    this.socket.on('mailWhishlistShowroomFood', data => {
      // console.log(this.exportDiscrepanciesId,' - ',data.exportDiscrepanciesId)
      // console.log('data.status => ', data.status)
      // if(this.exportDiscrepanciesId === data.exportDiscrepanciesId){
        switch (data.status){
          case 'pending':
          this.store.dispatch(new ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessPending(data));
            break;
  
          case 'success':
            this.store.dispatch(new ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessSuccess(data));
            break;
  
          case 'failed':
            this.store.dispatch(new ProductActionTypes.MailProductsLikesMailForFoodShowroomProcessFail(data));
            break;
        }
      // }
    })

    this.socket.on('whishlistShowroomFood', data => {
      // console.log(this.exportDiscrepanciesId,' - ',data.exportDiscrepanciesId)
      // console.log('data.status => ', data.status)
      // if(this.exportDiscrepanciesId === data.exportDiscrepanciesId){
        switch (data.status){
          case 'pending':
          this.store.dispatch(new ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessPending(data));
            break;
  
          case 'success':
            this.store.dispatch(new ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessSuccess(data));
            break;
  
          case 'failed':
            this.store.dispatch(new ProductActionTypes.SendProductsLikesMailForFoodShowroomProcessFail(data));
            break;
        }
      // }
    })

    this.socket.on('ExportDiscrepancies', data => {
      if (this.exportDiscrepanciesId === data.exportDiscrepanciesId) {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new ReportActions.ExportDiscrepancies(data));
            break;

          case 'success':
            this.store.dispatch(
              new ReportActions.ExportDiscrepanciesSuccess(data)
            );
            break;

          case 'failed':
            this.store.dispatch(
              new ReportActions.ExportDiscrepanciesFail(data)
            );
            break;
        }
      }
    });

    this.socket.on('ExportFollowDiscrepanciesUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new ReportActions.ExportFollowDiscrepanciesUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new ReportActions.ExportFollowDiscrepanciesSuccess(data)
          );
          break;

        case 'failed':
          this.store.dispatch(
            new ReportActions.ExportFollowDiscrepanciesFail(data)
          );
          break;
      }
    });

    this.socket.on('ExportFollowImgUpdate', data => {
      console.log('ExportFollowImgUpdate');

      switch (data.status) {
        // case 'pending':
        //   this.store.dispatch(new FileActions.DownloadImgUpdate(data));
        // break;

        case 'success':
          this.store.dispatch(new FileActions.DownloadImgSuccess(data));
          break;

        case 'failed':
          this.store.dispatch(new FileActions.DownloadImgFail(data));
          break;
      }
    });

    this.socket.on('ExportGroupCoversUpdate', data => {
      // if (this.exportGroupId === data.exportGroupId) {
        switch (data.status) {
          case 'pending':
            this.store.dispatch(new CoverActions.ExportGroupCoversUpdate(data));
            break;
  
          case 'success':
            this.store.dispatch(new CoverActions.ExportGroupCoversSuccess(data));
            break;
  
          case 'failed':
            this.store.dispatch(new CoverActions.ExportGroupCoversFail(data));
            break;
        }
      // }
    });
    this.socket.on('RetroplanningFileProcessUpdate', data => {
      switch (data.status) {
        case 'pending':
          this.store.dispatch(
            new RetroplanningActions.UploadProcessUpdate(data)
          );
          break;

        case 'success':
          this.store.dispatch(
            new RetroplanningActions.UploadProcessSuccess(data)
          );

          break;

        case 'failed':
          this.store.dispatch(new RetroplanningActions.UploadProcessFail(data));
          break;
      }
    });

    this.socket.on('GetSummaryData', data => {
        switch (data.status){
          case 'pending':
          this.store.dispatch(new followActions.GetSummaryDataPending(data));
            break;
  
          case 'success':
            this.store.dispatch(new followActions.GetSummaryDataSuccess(data));
            break;
  
          case 'failed':
            this.store.dispatch(new followActions.GetSummaryDataFail(data));
            break;
        }
      // }
    })

    this.socket.on('GenerateProductsImage', data => {
      switch (data.status){
        // case 'pending':
        // this.store.dispatch(new followActions.GetSummaryDataPending(data));
        //   break;

        case 'success':
          this.store.dispatch(new FileActions.ExportFollowSuccess(data));
          break;

        // case 'failed':
        //   this.store.dispatch(new followActions.GetSummaryDataFail(data));
        //   break;
      }
    // }
  })
  }

  reset(token) {
    if (!this.socket) {
      this.connect(token);
    } else {
      this.socket.close();
      this.connect(token);
    }
  }

  registerFileListener(fileId) {
    // console.log('aaaaaa', fileId)
    this.files.push(fileId);
  }
}
